<template>
    <div class="all-languages">
        <div class="language" v-for="lang in languages" @click="languageSet(lang)" :key="lang">{{lang | translate}}</div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      lan: null
    }
  },
  props: ['languages', 'language'],
  created: function (e) {
    this.lan = this.language
  },
  methods: {
    languageSet (l) {
      this.$emit('languageChange', l)
    }
  }
}
</script>
<style scoped>
    .all-languages {
        position: absolute;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        top: 16px;
        background-color: #FFF;
        box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.4);
    }
    .language {
      cursor: pointer;
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .language:hover {
        background-color: #880913;
        width: 100%;
        color: #FFF;
    }
    /*div[dir='ltr'] #languages[data-v-13a08622]*/
    @media only screen and (min-width: 2000px) {
      .all-languages {
        width: 473px;
        top: 63px;
      }
      .language {
        height: 150px;
        font-size: 60px;
        line-height: 60px;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/language-optionGroup.vue